<sui-select
  [ngModel]="currentLanguage"
  (ngModelChange)="handleLanguageChange($event)"
  (click)="$event.stopPropagation()"
>
  @for (language of languages; track language) {
    <sui-select-option
      [value]="language.code"
      [label]="getFlagEmoji(language.code) + ' ' + language.name"
      >{{ getFlagEmoji(language.code) }} {{ language.name }}</sui-select-option
    >
  }
</sui-select>
